import { UpdateInformationProps } from "components/BulkUpdateOptionalFieldsModal/types";
import React from "react";
import { useSelector } from "react-redux";
import { selectScanLabelsByScanIdLookup } from "selectors";
import { getIn, useFormikContext } from "formik";
import { getCheckboxFieldName } from "components/BulkUpdateOptionalFieldsModal/util";
import { pluralize } from "lib/pluralize";
import { UpdateInformationWrapper } from "components/BulkUpdateOptionalFieldsModal/UpdateInformationComponents";
import { EMPTY_ARRAY } from "lib";

export function UpdateInformationScanLabels(
  props: UpdateInformationProps,
): React.JSX.Element | null {
  const { field, modelIds, modelName } = props;
  const { fieldName } = field;

  const { values } = useFormikContext();

  const isSelected = getIn(values, getCheckboxFieldName(fieldName));

  const selectedValues: string[] = getIn(values, fieldName) || EMPTY_ARRAY;

  const isRemove = fieldName === "removeLabels";

  const scanLabelsByScanId = useSelector(selectScanLabelsByScanIdLookup);

  const affectedCount = isRemove
    ? modelIds.filter(scanId =>
        (scanLabelsByScanId[scanId] || []).some(scanLabel =>
          selectedValues.includes(scanLabel.name),
        ),
      ).length
    : modelIds.length;

  const pronoun = selectedValues.length === 1 ? "This" : "These";
  const noun = pluralize("label", selectedValues.length);
  const verb = isRemove ? "removed from" : "applied to";

  if (isSelected && selectedValues.length) {
    return (
      <UpdateInformationWrapper>
        {pronoun} {noun} will be {verb} {affectedCount}{" "}
        {pluralize(modelName, affectedCount)}.
      </UpdateInformationWrapper>
    );
  }

  return null;
}
